import { render } from "./MyVehicles.vue?vue&type=template&id=b08cc70c"
import script from "./MyVehicles.vue?vue&type=script&lang=js"
export * from "./MyVehicles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__